import { render, staticRenderFns } from "./page-terms.vue?vue&type=template&id=4c8641ec"
import script from "./page-terms.js?vue&type=script&lang=js&external"
export * from "./page-terms.js?vue&type=script&lang=js&external"
import style0 from "./page-terms.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports